// React
import React, { useState } from 'react'

import { useNavigate, useLocation } from 'react-router-dom'

// zxcvbn
import zxcvbn from 'zxcvbn'

import queryString from 'query-string'

// Appt
import Anchor from '../../simple/anchor/Anchor.js'
import Box from '../../simple/box/Box.js'
import Form from '../../simple/form/Form.js'
import FormField from '../../simple/formField/FormField.js'
import Meter from '../../simple/meter/Meter'
import Text from '../../simple/text/Text.js'
import TextInput from '../../simple/input/TextInput.js'
import ActionButton from '../actionButton/ActionButton.js'

/**
 * `PasswordReset` renders a PasswordReset screen
 */
function PasswordReset (props) {
  const navigate = useNavigate()
  const location = useLocation()

  const [password, setPassword] = useState({
    password: ''
  })
  const [strength, setStrength] = useState(null)

  const strengthLimit = {
    0: 'Insecure',
    1: 'Weak',
    2: 'Average',
    3: 'Good',
    4: 'Strong'
  }

  const strengthColor = {
    0: 'red',
    1: 'orangered',
    2: 'orange',
    3: 'yellowgreen',
    4: 'green'
  }
  const handleBackClick = () => navigate('/login')

  const handlePasswordChanged = (pwd) => {
    setPassword(pwd)

    if (!pwd.password.length) {
      setStrength(null)
    } else {
      let strength = zxcvbn(pwd.password).score

      if (pwd.password.length < 8) { 
        strength = 0
      }

      if (pwd.password.length < 10) { 
        strength = 1
      }


      setStrength(strength)
    }
  }

  const onSubmit = () => {
    // try {
    //   var passwordResetStatus = await PasswordService.resetPassword(organisationId, values.email)
    // } catch (err) {
    //   NotificationService.error(err)
    // }

    // NotificationService.info('Your password has been reset')

    const params = queryString.parse(location.search)
    props.handlePasswordReset(params.token, password)
  }

  return (
    <>
      <Box align='center' animation='fadeIn' pad='large' alignSelf='center' width='medium'>
        <Box width='small'>
          {/* <Image fit='contain' src={props.image} /> */}
          <Text color='white' margin={{ top: '30px', bottom: '30px' }} textAlign='center' weight='bold'>Change Password</Text>
        </Box>

        <Box width='medium'>
          <Form
            onChange={nextValue => {
              handlePasswordChanged(nextValue)
            }}
            onSubmit={() => onSubmit()}
            value={password}
          >
            <Text color='white' size='medium'>Your password should be at least 10 characters long and include a mix of upper and lower case letters, numbers, and special characters.</Text>
            {strength !== null &&
              <Meter background='light-2' max={5} size='full' thickness='xsmall' type='bar' values={[{ color: strengthColor[strength], value: strength + 1 }]} />}

            <FormField margin={{ vertical: 'small' }} name='password' required>
              <TextInput name='password' placeholder='Enter password' type='password' />
              {strength !== null ? <Text color={strengthColor[strength]}>{strengthLimit[strength]}</Text> : ''}
            </FormField>

            {password.password.length > 0 && strength < 2 &&
              <Text color='orange' size='small'>Your password is not strong enough. Please choose a stronger password.</Text>
            }
            {password.password.length > 0 && strength >= 2 && 
              <ActionButton fill='horizontal' label='Change Password' primary type='submit' />
            }

            <Box direction='row' justify='between' margin={{ top: 'medium' }}>
              <Anchor color='white' onClick={() => handleBackClick()} size='xsmall' label='< Back to login' />
            </Box>
          </Form>
        </Box>
      </Box>
    </>)
}

export default PasswordReset
